import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from '../AlertDialog'
import * as FA from 'react-icons/fa'
import { DateTime } from 'luxon'

import {
  Container,
  TextContainer,
  Label,
  InfoText,
  MoneyTextMask,
  SmallButton
} from './styles'

export default function Earning ({
  data: earning,
  enableEdit,
  onDelete: handleDelete
}) {
  const [showAlertDialog, setShowAlertDialog] = useState (false)
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }
  
  const deleteEarning = async () => {
    try {
      await cutileiApi.delete (`/earnings/${earning.id}`, requestConfig)
      handleDelete (earning)
    } catch (error) {
      logApiError (error)
    }
  }

  const toggleAlertDialog = () => setShowAlertDialog (!showAlertDialog)

  return (
    <Container key={earning.id}>
      <Label>
        ({DateTime.fromISO (earning.created_at).toFormat ('HH:mm')})
      </Label>
      <TextContainer>
        <InfoText>{earning.description}</InfoText>
      </TextContainer>
      <MoneyTextMask value={earning.value}/>
      {enableEdit && (
        <SmallButton onClick={toggleAlertDialog}>
          <FA.FaTrash color='#FF3939' size={12}/>
        </SmallButton>
      )}
      {enableEdit && (
        <AlertDialog
          visible={showAlertDialog}
          title='Atenção!'
          message='Deseja realmente excluir este suprimento?'
          confirmText='Sim'
          cancelText='Não'
          onConfirm={deleteEarning}
          onClose={toggleAlertDialog}
          dangerous={true}
        />
      )}
    </Container>
  )
}
